
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'h1fbdfea3ad6d664e': html`Selle on toonud
                    <a href="${0}">Folksonomy Engine projekt</a>. Ärge
                    kartke osaleda või tagasisidet anda.`,
'h5d824b4954e56ea5': html`Skaneeri oma <span class="everyday">igapäevaseid</span> <span class="foods">toiduaineid</span>`,
'h6bdd1b427aa985a4': html`See tööriist võimaldab teil koostisosade loetelu parandada. Saate lisada, eemaldada või muuta
                koostisosade loetelu.
                <br>
                See märk <span class="highlight">␣</span> tähistab tühikut.
                <br>
                See märk <span class="highlight">↩︎</span> tähistab reavahetust. `,
'hb28f1f2ec1744ee9': html`Need omadused on kasutajate loodud ja salvestatud igat tüüpi kasutuseks. Võid
                    lisada ka oma omadusi. Sinu loodud omadused ja väärtused
                    <strong>peavad olema faktilised</strong>. Võid süveneda
                    <a href="${0}">kogukonna poolt juba kasutatavate omaduste loendisse</a>
                    või uurida
                    <a href="${1}">omaduste dokumentatsiooni ja selle otsingumootorit</a>.`,
's000a5b76bd3a01c2': `Atribuutide laadimine...`,
's000d98595e959c1e': `Get It On Google Play`,
's013bdc8cf0d3583d': `Aidake meil koostisosade osas`,
's01d2865e3e1d5501': `Thank you for your assistance!`,
's02ce7a2e7c1b020b': `Saagi valideerimine`,
's03e9c8114521b998': `Ma muudan koostisosi`,
's05ec315d9308091a': `Vöötkoodi nurkade ikoon`,
's061eb5af92512c85': `Salvestatud! Kas saate aidata veel ühega?`,
's06847c221c4c0bc1': `Sooviksin luua atribuudi, et [kirjeldada teie kasutusjuhtu]...`,
's06f6c6f99db6b552': `Originaal`,
's081e2ad82db71e1d': `Rühmitatud väärtused`,
's09205907b5b56cda': `Ei`,
's0b4235aae602a950': `spetsiaalne dokumentatsioon`,
's0bb2d48532acc455': `Laadi alla CSV-fail`,
's0d5b7fee0311db68': `Kinnisvara`,
's0fb218abc2e157ed': `Kehtetuks tunnistatud pilt`,
's100c4928cc74642a': `support the advancement of public health research.`,
's10db5498186c083b': `Tühista kärpimine`,
's11a18a69b30b65ed': `Aidake meil koostisosade loetelus vigu parandada`,
's1205d5f6fccf8e69': `Kinnisvara väärtus`,
's15d64a0a6715285a': `Uus võti`,
's166bd56d19670a72': `Suurenda`,
's19059bf0c4f7c162': `Valikuala`,
's1a52515ec8ddade8': `Toote triipkood`,
's1c5031113de500ce': `keeping our database open &amp; available to all,`,
's1dc4daf989c71284': `Aidake meil toitumisalast teavet parandada`,
's1e00019dc454872d': `Palun sisestage atribuudi „property-name” abil atribuudi nimi.`,
's1e49126af0935a5b': `Selle omaduse kasutavate toodete loend`,
's21e73088de6f26f3': `Download on the App Store`,
's255857544a9d5ec0': `Reset`,
's25e94495991e95ba': `Thanks for your help! Can you assist with another question?`,
's2ceb11be2290bb1b': `Tühista`,
's2db7b654c0a9bde0': `Dokumenteerige vara`,
's300b3a6ee4e1252d': str`Halb vaste ${0}%`,
's33f786bb6b4f0cf4': `Kärpimistulemus`,
's33f85f24c0f5f008': `Salvesta`,
's34be4af4e8fec4ae': `Küsi kõigepealt kogukonnalt`,
's36d86adc823cbfa6': `Enne uue kinnisvara loomist arutage seda kogukonnaga:`,
's3781d25aa51a736c': `Folksonomy mootori dokumentatsioon`,
's383ae4449428b61e': `Lähtesta kärpimine`,
's39bcf88721a1e8ee': `Lähtesta valik`,
's39e14e14300694c7': `Dokumentatsioon ja juhised`,
's3b430cfa5c1fe7f4': str`Dokumentatsioon ${0}kohta`,
's3f4e4b52f230a892': `Pildi lõuend`,
's417b90913e05bc17': `Eelvaade`,
's41f7dca46d3f1b4a': `Väärtus`,
's422bba9636ce2489': `Keskele pilt`,
's42dd66b2441566fd': `Keskmise ikooni`,
's43df2e8395f6834e': str`Please give to our ${0} Fundraiser`,
's453188ea728f64da': `Lisa toitaine`,
's453ab0dbb9b5c777': `Suuruse muutmine paremale`,
's475b08749d0706ed': `Help us inform millions of consumers around the world about what they eat`,
's49730f3d5751a433': `Loading...`,
's4bbc7472834a9686': `Your browser does not support barcode scanning.`,
's4d42cc7e00076a3b': `Toodete arv`,
's4df2f533c0c1e7d0': `Pildi juhtelemendid`,
's4e94adf723979402': `Open Food Facts needs your help with this product.`,
's4f4886341969d552': `Valiku teisaldamine`,
's4f751fb9b3ed766c': `Uue vara loomine`,
's547c12ae169d00bc': `Available on F-Droid`,
's5560fb119e40923d': `Sisesta kinnisvara nimi...`,
's55d7249883a98ca1': `selle majutusasutuse kohta Open Food Factsi wikis`,
's565867d84c04aea2': `Filtri omadused...`,
's5666afe5cd0166de': `Palun parandage vead või muutke teksti enne kinnitamist`,
's57472465a23b41db': `Values`,
's58e1eeea7a60ae51': `Toodete laadimine...`,
's59df20feee978e5b': `Error: Invalid value.`,
's5c92c0051d44b6de': `Aidake meil toitumisalast teavet parandada.`,
's5dd6f12783fca34f': `Muuda koostisosade loendit`,
's5e8250fb85d64c23': `Sulge`,
's5ed03bb1f3a15949': `Picture`,
's6306a31415aea913': `I SUPPORT`,
's6498dfe4855bb3a7': `unit`,
's64ef2a6c2dd1d3d1': `Muuda`,
's66413c24dcf680e2': `Skip`,
's67ae6594857a4d57': `Tänan teid panuse eest!`,
's6cee7cad81dfedd1': `Kärbitud pilt`,
's6d7b6cdedaadfb6e': `Each donation counts! We appreciate your support in bringing further food transparency in the world.`,
's7124dde792a8faa2': `Android APK`,
's718dea04853f80ae': str`Hea vaste ${0}%`,
's71a5c9f4b68ef4d4': `Count`,
's74cb3d66f6a668e1': `Dokumentatsioon`,
's787dd11bed0dc88a': `Suuruse muutmine vasakule`,
's7ce4fd9430e80cea': `value`,
's801a05fa8e881f37': `Lisateave kinnisvara loomise ja juhiste kohta:`,
's8038273de2cf8b73': `Palun vali kärpimiseks piirkond.`,
's839cc2908a5387f2': `Filtreeri triipkoode...`,
's86197dcf3e96af64': `Sirvi ja otsi olemasolevaid kinnisvaraobjekte`,
's8a63be30a129a59c': `Alumise osa suuruse muutmine`,
's8a8bfd67f2dd2810': `Download the OFF app with this QR code`,
's8af61807443f32a4': `Actions`,
's8b33c244759d7bd4': `Suuruse muutmine paremas ülanurgas`,
's8db84aa4bc949af2': `Dokumenteerige uus kinnisvara`,
's8f839a03997a16d7': `Vaata toodet`,
's901ae1e236ac45d3': `Tühista kustutamine`,
's907f7a97c6b29425': `Arvestage, et andmemudelit võidakse muuta. Kasutage omal vastutusel.`,
's95d23d03f9147581': `Unzoom`,
's976dfd19ef58a1e1': `Click to scan a barcode and find out its details (health, preferences, etc.)`,
's98ff35f2a00dc60d': `Koostisosad:`,
's9a7f60fce090ecaf': `Atribuutide laadimine ebaõnnestus. Proovige hiljem uuesti.`,
's9b87abd68fb9df45': `Ei leitud? Loo uus võti {value}`,
's9c0f52425fd2f07e': `Ei pruugi sobida`,
's9fc41f789c63b40d': `Tooted`,
'sa1fa766e0d5634d7': `Skoor pole saadaval`,
'sa548778b24054030': `Avasta kõiki Folksonomy Engine'i projektist saadud teavet. Tegemist on täiendavate metaandmetega ja teabega Open Food Factsi andmebaasi toodete kohta.`,
'sa63907958bd0ec4b': `Muuda vasaku ülanurga suurust`,
'sa95b4224f685a36a': `Sule modaalaken`,
'sab56a1d439576fd6': `Soovituse ikoon`,
'sac47ea2901d04c15': `Muuda vasaku alumise nurga suurust`,
'sb125227d436c2925': `Otsi oma kinnisvarakontseptsiooni olemasolevast kinnisvaraandmebaasist:`,
'sb125568d43642e6f': `Vasta toote kohta käivatele küsimustele.`,
'sb1c538e038f9b214': str`Väga hea vaste ${0}%`,
'sb28639570ff3b852': `kõigi kinnisvaraobjektide loend`,
'sb3bdd638a58d30f4': `engage a community of committed citizens,`,
'sb3cbcc1bd0fff140': `Kui oled veendunud, et sinu vara pole olemas ja kogukond on nõus, et see on kasulik, pead selle kõigepealt vikis dokumenteerima.`,
'sb3d4f79d9d8b71e5': `Salvesta`,
'sb560fa37a7bfb6c2': `Selle kinnisvara kohta ei leitud tooteid.`,
'sb7f72e4c8a2d3357': `Filtreeri väärtusi...`,
'sb8178320160f84ea': `Näita kärpimist`,
'sbad7d2734149470b': `Validate`,
'sbb623d6b18d966a0': `Nutrition facts are displayed on the packaging:`,
'sbd6be5cde472f37c': `Kõikidele küsimustele on vastatud! Tänan abi eest!`,
'sbd9a0b2293b3cd3c': `Portsjoni suurus`,
'sbe472dc3c2685985': `Vastav väärtus`,
'sc0520e1732a5c568': `Expand image`,
'sc0cc559e7ede852a': `Ülemise suuruse muutmine`,
'sc1c08d0cbcc3bd24': `Ei vasta`,
'sc52696641af72b53': `Install the app!`,
'sc5575e3107f87874': `Rotate image to the left`,
'sc57b630a7a70c61f': `Soovituslik parandus`,
'sc681b137e8f604f7': `Kinnita kustutamine`,
'sc6daf8a31883f8b9': `Liiguta pilti`,
'sc895972c88d38ca5': `Folksonoomia vara`,
'sca0c3305aff570b8': str`per specified serving "${0}"`,
'scace072bef961918': `Read`,
'scb3b0671d7b7f640': `Uus väärtus`,
'scb489a1a173ac3f0': `Jah`,
'scbab4bd737ba7934': str`group photo donation ${0}`,
'scd21019c3cd618f3': `Liitu Slacki aruteluga`,
'scdb6cad0b92721bf': `Ühtegi objekti ei leitud.`,
'scf23a05631f93732': `Kinnita kustutamine`,
'scfed2f270ef6a3aa': `Valige piirkond`,
'sd1022bc1ef9204f7': `Suumitav pilt`,
'sd1077c055cf9ba6b': `Aidake meil toote koostisosade loetelu valideerida.`,
'sd698d21ddecba56b': `Tere! Saate aidata meil tooteteavet täiustada, vastates järgmistele küsimustele:`,
'sd82bc2decefa621b': `remain independent of the food industry,`,
'sdb97e5976482606e': `Kontrollige, kas atribuut on juba olemas`,
'sdbf806fefc584115': `Sa peaksid leidma`,
'sdc673e73b5c13aea': `Kustuta`,
'sdc792b75f1edcaba': `Aidake meil koostisosade õigekirja parandada.`,
'sdca5deead576ceee': `Muuda alumise parema suurust`,
'sdcc2555c5dde524f': `Kas olete kindel, et soovite selle üksuse kustutada? Seda toimingut ei saa tagasi võtta.`,
'se206feec7ec57b28': `100 g kohta`,
'se419a9ab36987490': `Kehtetuks tunnistamine`,
'se5127cf0f92e7e48': `Näpunäide: võid leida ka`,
'se773f50d2a16d481': `Rotate image to the right`,
'sebb2c6c830a44574': `technical infrastructure (website/mobile app) &amp; a small permanent team`,
'sec6377f3c4e9b28c': `Pakun välja parema saagi`,
'seea3800e27baa686': `Individuaalsed tooted`,
'sefaba4adc4ec9219': `Folksonoomia omadused`,
'seffa8ca49175b5f0': `Isikupärastatud omadused`,
'sf44a6b3b232c28ea': str`Asenda praegune väärtus ${0}-ga`,
'sf4cd86a2f5ef2588': `Toote vöötkood`,
'sf57a61152168cc81': `Aidake meil koostisosade tuvastamist parandada`,
'sf88b90b8ba23871c': `Tundmatu vaste`,
'sf9aee319a006c9b4': `Lisa`,
'sfacbbe968fa7d773': `Kinnisvara nimi:`,
'sfc40ea3d5d5aa6f8': `Your donations fund the day-to-day operations of our non-profit association:`,
'sfe87465d50530725': `Vastav väärtus`,
's5f343a43e7ea9f91': `Error`,
'sd947a599045e9e0e': `Failed to check property conflicts. Please try again.`,
's92a0d19a28995530': `Success`,
's371091f240c17a7e': `Property renamed successfully!`,
's4603f58131a777bf': `Failed to rename property. Please try again.`,
's21694d2ab9c0bec5': `Property deleted successfully!`,
'scf78b75273a6b5fe': `Failed to delete property. Please try again.`,
's71ffcb25fc1c5356': `Rename this property`,
's60320a18282b2b33': `Rename`,
's6e2a82009cc3dfc7': `Delete this property`,
's8bccacf0fc176064': `Rename Property`,
's0df37909a355e56f': str`Rename property '${0}' to:`,
'sb550440eeb3f39c5': `New property name:`,
'sbb53591e587764b7': `Enter new property name...`,
's8acd49e96b4ee7d4': `Check Conflicts`,
'sd1cfdf0ef29cb6a5': `Property Rename Conflicts`,
'sf417737adaa5a8c2': str`Renaming '${0}' to '${1}' will affect:`,
's14571d0ac58a8b43': `Products with both properties:`,
'sb0d459e32656033f': `Products with old property only:`,
'sfa3027dde47305fe': `Products with new property only:`,
's9e5b8feb0892646e': `Do you want to proceed with the rename?`,
's97171907a2d1620b': `Proceed with Rename`,
's712d70fdcc3dd42b': `Delete Property`,
'sc11b78f2f3173f75': str`Are you sure you want to delete the property '${0}'?`,
's3b3fe4e829af3e8e': `This action cannot be undone.`,
's091d3d07b5b3076f': `OK`,
's72c9c4e6ab4ca7ae': `Value replaced successfully!`,
'sdd0eacd725bb2b1d': `Failed to replace value. Please try again.`,
'sfe87a7a8bed11acf': `Value deleted successfully!`,
'sccd2745bdd1087f6': `Failed to delete value. Please try again.`,
's88ece9a678e2f106': `Replace Value`,
's3355d65e22e222c9': str`Replace all instances of '${0}' with a new value:`,
's0d426d718d97d14e': `New value:`,
'se80a1ed3dcab7408': `Enter new value...`,
's2a8434b16dc214a3': `Replace`,
's8263352c7a634e7f': `Delete Value`,
'sebe99e3299746177': str`Are you sure you want to delete all instances of the value '${0}'?`,
's4b0b53abbd6af54a': `Replace this value across all products`,
'sb02836b5e3176cfe': `Delete this value from all products`,
    };
  